// Libraries
import React, {useState} from 'react';
import {Modal} from 'antd';

// Types
import {ZoneType} from "../../types/storeTypes";

// Components
import ButtonComponent from '../subComponents/ButtonComponent';
import TableComponent from "../subComponents/TableComponent";


type PropsType = {
  zonesOfStore: ZoneType[];
  handleZonesDetailModal: (visible: boolean) => void;
};
const ZonesModal = (props: PropsType) => {
  const { zonesOfStore, handleZonesDetailModal } = props;
  const [pageSize, setPageSize] = useState<number>(20);

  const columns = [
    { title: "Código ZIP", dataIndex: ["location", "zipCode"], key: "zipCode", width: "100px" },
    { title: "Código Dane", dataIndex: ["location", "daneCode"], key: "daneCode", width: "100px" },
    { title: "Código Coordinadora", dataIndex: ["location", "coordinadoraCode"], key: "coordinadoraCode", width: "100px" },
    { title: "¿Activo?", dataIndex: ["location", "isActive"], key: "isActive", width: "100px",
      render: (isActive: boolean) =>  isActive ? 'SI' : 'NO'
    },
  ];

  return (
    <Modal title={`Zonas`}
           open={true} maskClosable closable={false} keyboard={false} destroyOnClose={true}
           width={700}
           footer={[
             <ButtonComponent key={'cancel'}
                              text={'Cerrar'}
                              className={'w-32 h-8 bg-white border border-grey-dkt-300 leading-4 text-grey-dkt-700 ' +
                                'hover:bg-grey-dkt-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-orange-dkt-400'}
                              onClick={() => handleZonesDetailModal(false)} />,
           ]}>
      <TableComponent pageSize={pageSize}
                      currentPage={1}
                      total={zonesOfStore.length}
                      dataSource={zonesOfStore}
                      scrollX={400}
                      rowKey={'zoneId'}
                      columns={columns}
                      onChangePage={(pagination) => {
                        setPageSize(pagination.size);
                      }} />
    </Modal>
  );
}

export default ZonesModal;